import { useDispatch, useSelector } from 'react-redux';
import type { AppDispatch, RootState } from '../../store';
import { hidePopup, showPopup } from '../../store/ai2';

export const usePopup = () => {
  const dispatch: AppDispatch = useDispatch();
  const openPopupId = useSelector((state: RootState) => state.popup.popupId);

  const handleOpenPopup = (id: string) => {
    dispatch(showPopup(id));
  };

  const handleClosePopup = () => {
    dispatch(hidePopup());
  };

  return {
    openPopupId,
    openPopup: handleOpenPopup,
    closePopup: handleClosePopup,
  };
};
